import {
    AdminCatalog,
    ArtistProfile,
    Home,
    Library,
    Marketplace,
    Pricing,
    Profile,
    Upload,
} from './pages';

const routes = [
  { path: '/', element: <Home /> },
  { path: '/admin/catalog', element: <AdminCatalog /> },
  { path: '/marketplace', element: <Marketplace /> },
  { path: '/pricing', element: <Pricing /> },
  { path: '/upload', element: <Upload /> },
  { path: '/artists/:id', element: <ArtistProfile /> },
  { path: '/library', element: <Library /> },
  { path: '/profile', element: <Profile /> },
  { path: '/profile/:userId', element: <Profile /> },
  { path: '/settings', element: <Profile initialTab="settings" /> },
];

export default routes;
